import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Row, Col, Button, Card, Form, Tab, Tabs, Table } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { LoginManager } from '../../core/login-manager';
import { toast } from 'react-toastify';
import { settings } from '../../config/settings';
import { Utils } from '../../core/utils';




export default function Profile() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(1);
    const [nome, setNome] = useState(null);
    const [cognome, setCognome] = useState(null);
    const [corsiCompletati, setCorsiCompletati] = useState(null);
    const userInfo = LoginManager.getUserInfo();
    const [user, setUser] = useState(null);



    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        getCorsiCompletati();
    }, [data]);


    async function init() {
        setData(LoginManager.getUserInfo());
        var res = await DataManager.getItem('user', userInfo.id);
        if (res.success === 1) {
            setUser(res.body[0]);
        }

    }


    async function getCorsiCompletati() {
        console.log(data)
        var constraints = [
            {
                "fieldName": "isCompleted",
                "type": "value",
                "value": 1
            }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('gyv_course_user', 1, 1000, sorting, '', [], constraints)
        console.log(response);
        if (response.success === 1 && response.body.length > 0) {
            setCorsiCompletati(response.body);
        }
    }

    function logout() {
        LoginManager.logout()
    }


    async function getCertificate(idCourse) {
        toast.info("Download in corso...", { theme: 'colored' })
        var gyv_course = corsiCompletati.filter(item => item.idCourse.id === idCourse);
        console.log(gyv_course);
        var resCourse = await DataManager.getItem('course', idCourse);
        if (resCourse.success === 1) {
            if (!Utils.isCourseEnded(resCourse.body[0].episodes)) {
                toast.info('Il certificato sarà disponibile dal ' + Utils.getCertificateAvailableFrom(resCourse.body[0].episodes).format('DD/MM/YYYY'), { theme: 'colored' })
                return
            }
            var courseDates = Utils.getCourseDates(resCourse.body[0].episodes)
            var sorting = {
                'field': 'id',
                'order': 'desc'
            }
            var constraints = [
                {
                    "fieldName": "defaultTemplate",
                    "type": "value",
                    "value": 1
                }
            ]
            var resFile = await DataManager.searchItems('certificate_template', 1, 100, sorting, '', [], constraints);
            console.log(resFile)
            if (resFile.success === 1) {
                const body = {
                    idCourse: idCourse,
                    hash: resFile.body[0].file.hash,
                    name: userInfo.name,
                    surname: userInfo.surname,
                    nameCourse: resCourse.body[0].name,
                    notes: resCourse.body[0].certificateNotes,
                    //description: resCourse.body[0].certificateDescription,
                    date: moment().format('DD/MM/YYYY'),
                    episodes: resCourse.body[0].episodes,
                    numberEpisodes: resCourse.body[0].episodes.length,
                    hour: Math.ceil(gyv_course[0].total_episodes_time / 3600),
                    cf: user.cf || "",
                    episodesStart: courseDates.start ? courseDates.start.format('DD/MM/YYYY') : '',
                    episodesEnd: courseDates.end ? courseDates.end.format('DD/MM/YYYY') : '',
                }

                var responseWord = await ApiManager.sendAuthenticatedRequest('/public/get_certificate', body);
                console.warn('CERTIFICATE', responseWord);
                if (responseWord.success !== 1) {
                    toast.error(responseWord.message || 'Errore nella generazione del certificato', { theme: 'colored' })
                    return
                }

                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraints = [
                    {
                        "fieldName": "hash",
                        "type": "value",
                        "value": responseWord.hash
                    }
                ]
                var res = await DataManager.searchItems('resource', 1, 100, sorting, '', [], constraints);
                console.log(res)
                if (res.success === 1) {
                    window.open(settings.ckdPath + 'upload/' + res.body[0].entity + '/' + res.body[0].filename)
                }
            }
        }
    }




    if (data) {

        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.profile')}</title>
                </Helmet>

                <Container fluid style={{ height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row className='my-5'>
                            <Col>
                                <h4 style={{ color: 'var(--primary-color)' }}>Ciao,</h4>
                                <h2 style={{ color: 'var(--primary-color)' }}>{data.name} {data.surname}</h2>
                            </Col>
                            <Col>
                                <h4 style={{ color: 'var(--primary-color)' }}>Statistiche</h4>
                                <Row>
                                    <Col className='my-1'>
                                        <div className='d-flex align-items-center text-white p-3 justify-content-center' style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px' }}>
                                            <h4 style={{ color: 'var(--primary-color)' }} className='mb-0'>{corsiCompletati && corsiCompletati.length > 0 ? corsiCompletati.reduce((acc, cur) => cur.isCompleted ? acc + cur.total_episodes : acc, 0) : 0}</h4>
                                            <h6 style={{ color: 'var(--primary-color)' }} className='ms-2 mb-0'>Capitoli<br />conclusi</h6>
                                        </div>
                                    </Col>
                                    <Col className='my-1'>
                                        <div className='d-flex align-items-center text-white p-3 justify-content-center' style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px' }}>
                                            <h4 style={{ color: 'var(--primary-color)' }} className='mb-0'>{corsiCompletati && corsiCompletati.length > 0 ? corsiCompletati.reduce((acc, cur) => cur.isCompleted ? acc + 1 : acc, 0) : 0}</h4>
                                            <h6 style={{ color: 'var(--primary-color)' }} className='ms-2 mb-0'>Corsi<br />conclusi</h6>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Tabs
                                    defaultActiveKey="corsi"
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                >
                                    <Tab eventKey="corsi" title="Corsi Conclusi">
                                        {corsiCompletati && corsiCompletati.length > 0 ? (
                                            <Table>
                                                <thead style={{ backgroundColor: 'var(--primary-color)' }}>
                                                    <tr>
                                                        <th>Nome corso</th>
                                                        <th>Data</th>
                                                        <th>Lezioni</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {corsiCompletati && corsiCompletati.map((corso, i) => {
                                                        if (corso.isCompleted) {
                                                            return (
                                                                <tr key={i}>
                                                                    <td>{corso.idCourse && corso.idCourse.name}</td>
                                                                    <td>{moment(corso.lastUpdate).format("DD/MM/YYYY")}</td>
                                                                    <td>{corso.total_episodes}</td>
                                                                    {corso.idCourse?.hasCertificate === 1 ? <>
                                                                        <td>
                                                                            <Button variant='light' className='rounded-pill' style={{ borderColor: 'var(--primary-color)', backgroundColor: 'white', color: 'var(--primary-color)' }} onClick={() => { getCertificate(corso.idCourse.id) }}>Certificato<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                                                        </td>
                                                                    </> : null}
                                                                </tr>
                                                            )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>) : (<>
                                                <Row>
                                                    <Col className='text-center'>
                                                        <p className='text-muted text-center'>Nessun corso completato.</p>
                                                        <Button className='rounded-pill' onClick={() => navigate('/corsi')}>Vai ai corsi</Button>
                                                    </Col>
                                                </Row>

                                            </>)}

                                    </Tab>
                                    <Tab eventKey="utente" title="Dati Utente">
                                        <Container style={{ borderRadius: '20px' }} className='p-3'>
                                            <Row>
                                                <Col md={3} xs={12} className='my-1'>
                                                    <Form.Label>Nome</Form.Label>
                                                    <Form.Control type="text" onChange={(e) => setNome(e.target.value)} placeholder={data.name} className='rounded-pill' disabled />
                                                </Col>
                                                <Col md={3} xs={12} className='my-1'>
                                                    <Form.Label>Cognome</Form.Label>
                                                    <Form.Control type="text" onChange={(e) => setCognome(e.target.value)} placeholder={data.surname} className='rounded-pill' disabled />
                                                </Col>
                                                <Col md={3} xs={12} className='my-1'>
                                                    <Form.Label>Username</Form.Label>
                                                    <Form.Control type="text" placeholder={data.username} className='rounded-pill' disabled />
                                                </Col>
                                                <Col md={3} xs={12} className='my-1'>
                                                    <Form.Label>Codice fiscale</Form.Label>
                                                    <Form.Control type="text" placeholder={data.cf} className='rounded-pill' disabled />
                                                </Col>
                                            </Row>
                                            <a href="https://crm.fedespedi.it/profile">
                                                <Button className='mt-4'>Modifica dati utente</Button>
                                            </a>
                                        </Container>

                                    </Tab>
                                    <Tab eventKey="logout" title="Logout">
                                        <h4>{LanguageProvider.get('logout.title')}</h4>
                                        <p className='lead'>{LanguageProvider.get('logout.subtitle')}</p>
                                        <Button className="me-2" onClick={() => logout()} variant='danger' size='lg'>{LanguageProvider.get('logout.confirm')}</Button>
                                    </Tab>
                                </Tabs>
                            </Col>
                        </Row>
                    </Container>

                </Container>

            </>
        )

    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
            </Container>
        )
    }
};